<template>
    <div
        class="detail-list d-flex align-items-center justify-content-between"
        :class="{ 'border-bottom': showBottomBorder }"
        style="gap: var(--space-2)"
    >
        <div class="d-flex flex-column detail-list-content" style="gap: var(--space-2)">
            <p v-if="header" class="content-font text-muted mb-0">
                {{ header }}
            </p>
            <slot> </slot>
            <p v-if="subDetail" class="content-font text-muted mb-0">
                {{ subDetail }}
            </p>
        </div>
        <IconButton
            v-if="showIcon"
            preset="view"
            @click="handleIconClick"
        />
    </div>
</template>

<script>
import IconButton from '@/components/IconButton.vue';

export default {
    name: 'DetailList',
    components: {
        IconButton,
    },
    props: {
        header: {
            type: String,
            default: '',
        },
        subDetail: {
            type: String,
            default: '',
        },
        showBottomBorder: {
            type: Boolean,
            default: false,
        },
        showIcon: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['icon-click'],
    methods: {
        handleIconClick() {
            this.$emit('icon-click');
        },
    },
};
</script>

<style scoped>
.detail-list {
    padding-block: 0.625rem;
    max-width: 100%;
    min-width: 0;
}

.detail-list-content {
    flex: 1;
    max-width: 100%;
    min-width: 0;
}

.border-bottom {
    border-bottom: 1px solid var(--neutral-600);
}

.content-font {
    font-size: 0.875rem;
    line-height: 1.2;
    font-weight: 400;
}

@media (max-width: 767.98px) {
    .icon-btn {
        width: 2.5rem;
        height: 2.5rem;
        font-size: 1.25rem;
    }
}
</style>
